import { z } from "zod";
import { ColumnSchema, ViewSchema, ViewType } from "./views";

export enum ClassesColumn {
    NAME = "name",
    PERCENTAGE = "percentage",
    TRANSACTIONS = "transactions",
    ACTIONS = "actions",
}

const NameColumnSchema = ColumnSchema.extend({
    id: z.literal(ClassesColumn.NAME),
});

const PercentageColumnSchema = ColumnSchema.extend({
    id: z.literal(ClassesColumn.PERCENTAGE),
});

const TransactionsColumnSchema = ColumnSchema.extend({
    id: z.literal(ClassesColumn.TRANSACTIONS),
});

const ActionsColumnSchema = ColumnSchema.extend({
    id: z.literal(ClassesColumn.ACTIONS),
});

export const ClassesViewSchema = ViewSchema.extend({
    type: z.literal(ViewType.CLASSES),
    columns: z.array(
        z.discriminatedUnion("id", [
            NameColumnSchema,
            PercentageColumnSchema,
            TransactionsColumnSchema,
            ActionsColumnSchema,
        ]),
    ),
});

export type ClassesView = z.infer<typeof ClassesViewSchema>;
